import type { RouteObject } from 'react-router';
import { READABLE_OFFLINE } from '../../core/pwa/works-offline';

/**
 * One route. The Tickler is a single list — there is no per-date screen and no detail view, because
 * the rows carry every control a container screen's rows carry (FR-013) and a date is not a thing you
 * navigate into.
 *
 * Lazy, like every other feature route: the screen is reached deliberately rather than on the way to
 * somewhere else, so its chunk should not be in the initial bundle.
 *
 * 036 (issue 221, FR-021): readable offline — its one read is the same `view=deferred` request home
 * already makes, so a stored view is already on the device by the time this screen is visited.
 */
export const routes: RouteObject[] = [
  {
    index: true,
    handle: { [READABLE_OFFLINE]: true },
    lazy: async () => ({ Component: (await import('./tickler-page')).default }),
  },
];
